<template>
    <div>
        <form @submit.prevent="submitFormData">
            <div class="row border-top pt-3">
                <div class="col-sm-12 col-md-6 border-right">
                    <div class="form-group">
                        <label class="form-label">{{$t('label.title')}}</label>
                        <div class="input-group bg-white shadow-inset-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0">
                                    <i class="fas fa-text"></i>
                                </span>
                            </div>
                            <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.title')" v-model="title" required="">
                        </div>
                    </div>
                    <div class="mt-3 form-group">
                        <label class="form-label">{{$t('label.details')}}</label>
                        <textarea class="form-control" :placeholder="$t('label.details')" rows="8" v-model="details"></textarea>
                    </div>
                    <div class="row mb-3">
                        <div class="col-sm-12 col-md-6 mb-2">
                            <div class="form-group">
                                <label class="form-label">{{$t('table.value.min') + ' ' + $t('label.price')}}</label>
                                <div class="input-group bg-white shadow-inset-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0">
                                            <i class="fas fa-dollar-sign"></i>
                                        </span>
                                    </div>
                                    <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('table.value.min') + ' ' + $t('label.price')" @keypress="isNumber($event)" v-model="minPrice" required="">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 mb-2">
                            <div class="form-group">
                                <label class="form-label">{{$t('table.value.max') + ' ' + $t('label.price')}}</label>
                                <div class="input-group bg-white shadow-inset-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0">
                                            <i class="fas fa-dollar-sign"></i>
                                        </span>
                                    </div>
                                    <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('table.value.min') + ' ' + $t('label.price')" @keypress="isNumber($event)" v-model="maxPrice" required="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6">
                    <h6 class="text-dark fw-500">{{$t('table.header.image')}}:</h6>
                    <div id="imageContainer" v-if="image != ''" class="text-center mt-3">
                        <div class="text-right mb-2 mr-2">
                            <button class="btn btn-sm btn-outline-primary" type="button" :title="$t('header.delete_image')" @click="showModal">
                                <span class="fal fa-trash" ></span>
                            </button>
                        </div>
                        <a @click="handleDropzone('img-thumbnail')" :title="$t('button_link.click_upload')" class="m-auto">
                            <img class="img-fluid img-thumbnail" :src="image"/>
                        </a>
                    </div>
                    <div v-else class="mt-2"> 
                        <vue-dropzone ref="dropzone" class="text-center" id="dropLogo" :options="dropOptions" @vdropzone-success="dropLogo"></vue-dropzone>
                    </div>
                </div>
            </div>
            <div class="border-top pt-3 mt-3 mb-3">
                <div class="row">
                    <div class="col-6">
                        <button type="button" class="btn border-0 btn-secondary btn-padding waves-effect waves-themed mr-3" @click="returnTreatment">{{$t('button_link.cancel')}}</button>
                        <button v-if="!isEdit" type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
                        <button v-else type="button" class="btn border-0 btn-primary btn-padding waves-effect waves-themed" @click="saveTreatmentInfo">{{$t('button_link.next')}}</button>
                    </div>
                </div>
            </div>
        </form>
        <deleteModal ref="deleteModal" @performConfirmAction="deleteImage"></deleteModal>
    </div>
</template>
<script>
import vueDropzone from "vue2-dropzone";
import DeleteModal from './../../Delete_Modal'
import {isNumber} from './../../../../assets/js/dashboard/utilities'
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'treatmentForm',
    components:{
        DeleteModal, vueDropzone
    },
    props:{
        isEdit: Boolean
    },
    data(){
        return{
            itemID: 0,
            isUpload: false, 
            image: "", addImagePath: "",
            title: "", details: "", minPrice: 0, maxPrice: 0,
            dzShow: true,
            dropOptions: {
                url: this.$api.API_IMAGE,
                addRemoveLinks: true,
                maxFiles: 1,
                paramName: 'filename',
                headers:{
                    token: this.$util.getSessionToken()
                }
            },
        }
    },
    methods: {
        isNumber(e){
            return isNumber(e);
        },
        resetForm(){
            this.isUpload = false
            this.title = this.details = this.image = ""
            this.dzShow = true
            this.minPrice = this.maxPrice = 0
        },
        closeModal(isError){
            if(!isError){
                if(this.$refs.deleteModal.toggleModal){
                    this.$refs.deleteModal.toggleModal = false
                }else if(this.isUpload){
                    this.isUpload = false
                }else{
                    this.returnTreatment()
                    this.resetForm()
                }
            }
            
            this.$parent.$parent.$parent.isModalShow = false
        },
        returnTreatment(){
            this.$emit('returnTreatment');
        },
        showModal(){
            var title = this.$i18n.t('header.delete_image')
            var message = this.$i18n.t('message.confirmation.delete_image')
            this.$refs.deleteModal.showModal(title, message)
        },
        deleteImage(){
            this.image = ""
            this.$refs.deleteModal.toggleModal = false
            this.dzShow = true
        },
        editTreatment(item){
            this.itemID = item.TnTreatmentID;
            this.title = item.TnTreatmentName
            this.details = item.TnTreatmentDetails
            this.minPrice = item.TnTreatmentMinPrice
            this.maxPrice = item.TnTreatmentMaxPrice
            this.image = item.TnTreatmentImage

        },
        dropLogo(file, response){
            if(response.path == undefined){
                this.$parent.$parent.$parent.setModal(this, false, true, this.$i18n.t('message.error.upload'));
            }else{
                this.dzShow = false
                this.$parent.$parent.$parent.setModal(this, false, true, this.$i18n.t('message.success.upload'));
                this.image = response.path
                this.$refs.dropzone.removeFile(file)
            }
            this.isUpload = true
        },
        setFormData(){
            var data = {
                TnTreatmentName: this.title,
                TnTreatmentDetails: this.details,    
                TnTreatmentMinPrice: this.minPrice,
                TnTreatmentMaxPrice: this.maxPrice,
                TnTreatmentImage: this.image
            }
            return data
        },
        saveTreatmentInfo(){
            var data = this.setFormData()
            data.TnTreatmentID = this.itemID
            this.$emit('saveTreatmentInfo', data)
        },
        submitFormData(){
            var data = this.setFormData()

            let url = this.$api.MENU_TREATMENT
            // let url = this.isEdit ?  _url + "/" + this.itemID + this.$api.UPDATE : _url

            let $vm = this
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: data,
            })
            .then((response) => {
                if(response.status == 200){
                    var action = $vm.isEdit ? $vm.$i18n.t('message.success.action.update') : $vm.$i18n.t('message.success.action.add')
                    var retData = response.data[0];
                    var message = retData.TnTreatmentName + "' " + $vm.$i18n.t('message.success.success', {'action': action})
                    $vm.$parent.$parent.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }else{
                    $vm.$parent.$parent.$parent.setModal($vm, true, true,  $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
        handleDropzone(strClass){
            var parent = document.getElementById("imageContainer");
            const imgs = parent.getElementsByClassName(strClass)
            
            var j = 0;
            if(imgs.length > 0){
                for(var i=0; i<imgs.length;){
                    var img = imgs[i];
                    var link = img.parentElement;

                    if(img.classList.contains('img-thumbnail')){
                        img.classList.remove('img-thumbnail');
                        img.classList.add('item-image');

                        link.classList.remove('m-auto');
                        link.classList.add('mr-2');
                        link.setAttribute('title', '');
                        parent.classList.add('d-flex');

                        this.dzShow = true;
                    }else{
                        img.classList.add('img-thumbnail');
                        img.classList.remove('item-image');

                        link.classList.add('m-auto');
                        link.classList.remove('mr-2');
                        link.setAttribute('title', this.$i18n.t('button_link.click_upload'));
                        parent.classList.remove('d-flex')

                        this.dzShow = false;
                    }
                    j++;
                }
            }
        },
    }
}
</script>